import { createContext, useContext } from 'react';

type NonceContext = {
  nonce: string;
};

const defaultValue: NonceContext = {
  nonce: '',
};

const context = createContext(defaultValue);
const { Provider } = context;

const useNonce = (): string => useContext<NonceContext>(context).nonce;

export { NonceContext, Provider, defaultValue, useNonce };
